import * as React from "react";
import { FieldValueCheckboxList } from "typings/index";
import { BaseFieldEditor } from "../helper";
import { connect } from "react-redux";
import { RootState } from "~/state";
import styled from "styled-components";
import { DefaultButton, Checkbox, DialogFooter, Dialog, TextField, PrimaryButton } from "office-ui-fabric-react";

import { getFieldValues } from "~/state/action";
import { loadFieldValues } from "~/state/field/action";

export interface Props extends BaseFieldEditor
{
    value: FieldValueCheckboxList;
    placeholder?: string;
}
const  CheckBoxListStyle = styled.div`
    background: white;
    padding: 10px;
    button{
        margin-top: 10px;
        clear:both;
        display: block;
    }
    .ms-Checkbox
    {
        float: left;
        margin: 5px;
    }
    
`;

const CheckBoxList: React.FunctionComponent<Props & StateProps> = props =>
{
    const [addNewValue, setAddNewValue] = React.useState<boolean>(false);
    const [newValueText, setNewValueText] = React.useState<string>("");

    React.useEffect(() =>
    {
        if (props.value && props.value.valuesUrl)
        {
            props.loadFieldValues(props.field.name, props.value.valuesUrl);
        }
    }, []);
    const onToggleNewValue = React.useCallback(() => setAddNewValue(!addNewValue), [addNewValue]);

    const onNewValueChange = React.useCallback((event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) =>
    {
        if (newValue)
        {
            setNewValueText(newValue);
        }
    }, []);

    const onSaveNewValue =  React.useCallback(() =>
    {
        const checkboxList = props.value && props.value.value || [];
        if (newValueText)
        {
            const fieldValue: FieldValueCheckboxList = { ...props.value, value: [...checkboxList, newValueText] };
            props.onValueChange(fieldValue);
        }
        setAddNewValue(false);
        setTimeout(() =>
        {
            if (props.value && props.value.valuesUrl)
            {
                props.loadFieldValues(props.field.name, props.value.valuesUrl);
            }
        }
        , 1000);
    }, [props.value, newValueText]);
    
    const onCheckboxClick = React.useCallback((clickedValue: string ) => () =>
    {
        const checkboxList = props.value && props.value.value || [];
        if (checkboxList.indexOf(clickedValue) > -1)
        {
            const value = checkboxList.filter(d => d !== clickedValue);
            const fieldValue: FieldValueCheckboxList = { ...props.value, value };
            props.onValueChange(fieldValue);
          
        }
        else
        {
            const value = [...checkboxList, clickedValue];
            const fieldValue: FieldValueCheckboxList = { ...props.value, value };
            props.onValueChange(fieldValue);
          
        }
        setTimeout(() =>
        {
            if (props.value && props.value.valuesUrl)
            {
                props.loadFieldValues(props.field.name, props.value.valuesUrl);
            }
        }
        , 1000);
    }, [ props.value]);

    const renderCheckboxList = React.useCallback(() =>
    {
        const checkboxList = props.value && props.value.value || [];
        return props.values.map((item, index) =>
        {
            return <Checkbox onChange={onCheckboxClick(item)} checked={checkboxList.indexOf(item) > -1} label={item} key={index} />;
        });
    }, [ props.value, props.values]);

    return (
        <CheckBoxListStyle>
            <div>
                {renderCheckboxList()}
            </div>
            <Dialog hidden={!addNewValue} onDismiss={onToggleNewValue}>
                    <TextField  onChange={onNewValueChange}></TextField>
                <DialogFooter>
                    <PrimaryButton onClick={onSaveNewValue} text="Create" />
                    <DefaultButton onClick={onToggleNewValue} text="Cancel" />
                </DialogFooter>
            </Dialog>
            <DefaultButton 
                disabled={props.disabled} 
                iconProps={{iconName: "Add"}} 
                onClick={onToggleNewValue}
                text={"Add"} 
            />
        </CheckBoxListStyle>
    );
    
};



const mapStateToProps = (state: RootState, ownProps: Props) => ({
    values: getFieldValues(state, ownProps.field.name) || []
});

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    loadFieldValues: (fieldName: string, valuesUrl: string) => dispatch(loadFieldValues(fieldName, valuesUrl))
});
type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(CheckBoxList);


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/checkboxList/index.tsx